<template>
  <div class="relative h-28 sm:h-48 w-full rounded-br-2xl">
    <img
      alt="image"
      :class="[imageUrl ? 'visible' : 'invisible']"
      class="h-full w-full rounded-b-2xl absolute top-0 object-cover"
      :src="imageUrl"
    />
    <hr
      class="
        h-full
        w-full
        object-cover
        absolute
        top-0
        bg-black
        rounded-b-2xl
        bg-opacity-60
      "
    />
    <div
      class="
        absolute
        h-full
        w-full
        p-2
        left-0
        top-0
        sm:top-10
        text-white
        grid grid-cols-5
      "
    >
      <img
        :class="[imageUrl ? 'h-32 w-32' : 'h-8 w-8 animate-spin']"
        alt="image"
        @click="viewDescription"
        class="
          overflow-hidden
          sm:h-48
          rounded-full
          place-self-center
          col-span-2
        "
        :src="imageUrl ? imageUrl : require('@/assets/icons/spinner.svg')"
      />
      <div class="overflow-y-auto h-24 col-span-3 px-2">
        <p class="font-bold text-xl text-right uppercase">
          <span class="text-bnb-mustard">{{ today }}</span>
        </p>
        <p class="font-bold text-left">
          {{ $store.getters.daySpecial?.title }}
        </p>
        <p class="text-xs text-left">
          {{ $store.getters.daySpecial?.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";
var days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export default {
  created() {
    this.fetchCachedImage();
  },
  data() {
    return {
      imageUrl: "",
    };
  },
  computed: {
    daySpecial() {
      return this.$store.getters.daySpecial?.title;
    },
    today() {
      var date = new Date();
      return days[date.getDay()];
    },
  },
  methods: {
    fetchCachedImage() {
      var title = this.$store.getters.daySpecial?.title;
      var urlImage = this.$store.getters.daySpecial?.imageUrl;
      Filesystem.readFile({
        path: `menuImages/${title}`,
        directory: Directory.Data,
        encoding: Encoding.UTF8,
      })
        .then((result) => {
          this.imageUrl = result.data.slice(result.data.indexOf("data:image/"));
        })
        .catch(() => {
          this.imageUrl = urlImage;
        });
    },
    viewDescription() {
      this.$router.push({
        name: "MenuDescription",
        params: { menuID: this.$store.getters.daySpecial?.id },
      });
    },
  },
  watch: {
    daySpecial() {
      this.fetchCachedImage();
    },
  },
};
</script>
